import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Grid } from '@adc/ui-adc'
import { CompleteRegistrationDepositBanner } from '../../../components/completeRegistrationDepositBanner'
import Ribbon from './ribbon'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface ContainerProps {
  left?: React.ReactNode
  ribbonColor?: string
  right?: React.ReactNode
  rightRibbon?: React.ReactNode
}

export const Container = ({
  left,
  ribbonColor,
  right,
  rightRibbon,
}: ContainerProps) => {
  return (
    <div className={cx('container')}>
      <CompleteRegistrationDepositBanner inline />
      {rightRibbon}
      <Grid
        as='section'
        centered
        className={cx('bid-banner')}
        data-elm-id='bid_banner'
        id='bid_banner'
        stretched
      >
        <Grid.Column
          mobile={16}
          tablet={right ? 10 : 16}
          computer={right ? 10 : 16}
        >
          <Ribbon
            containerClassName={cx('left')}
            data-elm-id='left'
            color={ribbonColor}
          >
            <div className={cx('left-content')}>{left}</div>
          </Ribbon>
        </Grid.Column>
        {right && (
          <Grid.Column mobile={16} tablet={6} computer={6}>
            <div className={cx('right')} data-elm-id='right'>
              {right}
            </div>
          </Grid.Column>
        )}
      </Grid>
    </div>
  )
}

interface MarginSectionProps {
  left?: boolean
  right?: boolean
  containerClassName?: string
  children: React.ReactNode
}

export const MarginSection = ({
  left,
  right,
  containerClassName,
  children,
  ...rest
}: MarginSectionProps) => (
  <div
    className={cx(
      'margin-section',
      left && 'margin-left',
      right && 'margin-right',
      containerClassName
    )}
    {...rest}
  >
    {children}
  </div>
)

export const LeftMarginSection = (props: any) => (
  <MarginSection left {...props} />
)
